<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h1 class="calibre15" id="pgepubid00007"><span class="calibre16">NINETY-FIRST DAY</span><br class="calibre5"/> Tuesday, 26 March 1946</h1>
</div>
<h2 class="nobreak" id="pgepubid00008"><span>Morning Session</span></h2>
<p class="pindent">MARSHAL: If it please the Tribunal, Defendant Streicher will
be absent from this session of the Court.</p>
<p class="pindent">PRESIDENT: Yes, Dr. Seidl.</p>
<p class="pindent">DR. SEIDL: Mr. President, Your Honors, I now turn to the reading
of the interrogation of the witness Alfred Hess.</p>
<p class="pindent">THE PRESIDENT: Where shall we find it?</p>
<p class="pindent">DR. SEIDL: Mr. President, I received this transcript of the interrogation
of the witness only last Saturday, and it has thus not been
possible for me to incorporate it into the document book as yet. This
witness was interrogated at Bad Mergentheim on 19 March.</p>
<p class="pindent">THE PRESIDENT: Do you mean that we haven’t got copies of it?</p>
<p class="pindent">DR. SEIDL: I do not know whether the General Secretary, from
whom I received this transcript, has supplied a copy for the Tribunal.</p>
<p class="pindent">THE PRESIDENT: Well, you had better go on then. Go on.</p>
<p class="pindent">DR. SEIDL: Yes. Before answering the first question, the witness
made a few preliminary remarks which are as follows:</p>
<div class="blockquote">
<p class="calibre3">“It should be noted that I had to terminate my activity in the
Auslands-Organisation of the NSDAP after the flight to England
of my brother Rudolf Hess, Deputy of the Führer.
Therefore, the following statements are valid only for the
period up to 12 May 1941.</p>
<p class="calibre3">“Question 1: ‘What were the tasks and the purpose of the
Auslands-Organisation of the NSDAP?’</p>
<p class="calibre3">“Answer: ‘The purpose of the Auslands-Organisation was the
cultural, social, and economic care of all German nationals in
foreign countries, regardless of whether they were Party
members or not. The Auslands-Organisation in this sense was
to be a bridge between Germans abroad and the home country.
Its purpose was to foster and maintain love for and ties with
the distant home country and to keep alive understanding for
the fatherland, as well as to awaken the understanding of
Germans at home for the hard battle for existence of their
compatriots all over the world. The German abroad, through
<span id="Page_76" title="76"></span>
his dignified, upright bearing, was to make himself popular in
the country of his adoption, and thus act as the best representative
of his fatherland.’</p>
<p class="calibre3">“Question 2: ‘Who could become a member of the Auslands-Organisation?’</p>
<p class="calibre3">“Answer: ‘The question is not understandable. There was no
such thing as a membership in the Auslands-Organisation;
just as little, for example, as there was a membership in the
Foreign Office of the Reich or in a Gau of the NSDAP in the
Reich.’</p>
<p class="calibre3">“Question 3: ‘Is it correct that on the membership card of each
Reich German Party member the following principle was
printed as a ruling principle of the Auslands-Organisation:
“Follow the laws of the country whose guest you are, let its
people make the internal policy of that country, do not interfere
in this, not even in conversation”?’</p>
<p class="calibre3">“Answer: ‘It is correct that the above principle, among similar
ones, was printed on the membership card or on its cover. If
I am not mistaken, underneath this principle there was the
warning even of expulsion from the NSDAP if this principle
was not observed. This latter is to be ascertained without
great difficulty by procuring a cover, which was in the possession
of every Party member in a foreign country.’</p>
<p class="calibre3">“Question 4: ‘Did the Auslands-Organisation of the NSDAP
develop any activity which could appear as Fifth Column?’</p>
<p class="calibre3">“Answer: ‘ “Fifth Column” is not a clear concept, uniformly
used. In general, it would probably mean secret espionage or
sabotage activity. According to its guiding principles, the
Auslands-Organisation could not have carried on any such
activity.’</p>
<p class="calibre3">“ ‘I remember that the slogan “Fifth Column” of the foreign
press was considered in the Auslands-Organisation as a clever
bluff of the antifascist propaganda, and it caused genuine
amusement. Seriously, no state could conceive that such a
widely known, rather suspect and vulnerable organization
could be suited for any service in the nature of the Fifth
Column. I consider it natural that some individual Germans
abroad had secret missions, services such as other nationals
performed likewise for their fatherland, but the Auslands-Organisation
was certainly not the giver of such assignments
nor the intermediary for such agents.’</p>
<p class="calibre3">“Question 5: ‘What kind of instructions and directives did the
Deputy of the Führer give the Auslands-Organisation for its
activity?’
<span id="Page_77" title="77"></span></p>
<p class="calibre3">“Answer: ‘The instructions and directives of the Deputy of
the Führer for the activity of the Auslands-Organisation are
such as those mentioned in my answers to Questions 1 and 3.
He pointed out again and again, with special emphasis, his
strict instructions that the groups abroad were not to do
anything which could be detrimental to the countries affording
them hospitality, or which could be considered an interference
in the affairs of those countries. The basic principle must also
be that National Socialism was a purely German movement,
not an article for export which one wanted to force on other
countries as suitable for them.’</p>
<p class="calibre3">“Question 6: ‘Did the Deputy of the Führer give the Auslands-Organisation
any directions or orders which could have caused
them to carry on an activity similar to that of the Fifth
Column?’</p>
<p class="calibre3">“Answer: ‘The Deputy of the Führer not only never issued
any such directions or orders, but as stated above in Answer 5,
laid down principles which absolutely prohibited any activity
of the sort carried on by the so-called Fifth Column.’</p>
<p class="calibre3">“Question 7: ‘Is it correct that, on the contrary, the Deputy of
the Führer took meticulous care that in all circumstances
interference in the internal affairs of the country of adoption
was to be avoided?’</p>
<p class="calibre3">“Answer: ‘I can repeat only that it was a chief concern of the
Deputy of the Führer to direct the work of the Auslands-Organisation
abroad in such a way that no interference of any
kind should take place in the internal affairs of the country of
residence. The few insignificant offenses, which were unavoidable
with the then very large number of German nationals
abroad—already amounting to several million—were correspondingly
severely punished.’</p>
<p class="calibre3">“Question 8: ‘What were the tasks and the aims of the Volksbund
für das Deutschtum im Ausland (League for Germans
Abroad)?’</p>
<p class="calibre3">“Answer: ‘The Volksbund für das Deutschtum im Ausland had
the cultural care of the so-called Volksdeutsche. Volksdeutsche
are racial Germans who had lost their German citizenship
either voluntarily or through the laws of other countries, that
is, had acquired the citizenship of another country, for instance,
America, Hungary, Transylvania, <span class="it1">et cetera</span>.’</p>
<p class="calibre3">“Question 9: ‘Did the Volksbund für das Deutschtum im Ausland
ever, in particular however before 10 May 1941, develop
any activity which could have given it the appearance of a
Fifth Column?’
<span id="Page_78" title="78"></span></p>
<p class="calibre3">“Answer: ‘I must state in this connection that the activity of
the Auslands-Organisation did not have anything to do with
the Volksbund für das Deutschtum im Ausland, so I can have
no insight into its work. But I consider it entirely out of the
question that my brother could have given the Volksbund
tasks of a Fifth Column nature. It would neither have fallen
within the jurisdiction of the Deputy of the Führer, nor have
corresponded with his views as to the mission of the Volksbund
für das Deutschtum im Ausland.’</p>
<p class="calibre3">“Question 10, and last question: ‘What kind of directions and
instructions did the Deputy of the Führer give as to the
activity of this Bund?’</p>
<p class="calibre3">“Answer: ‘Directions, <span class="it1">et cetera</span>, which my brother gave as to
the activity of this Bund are unknown to me, for, as already
stated, my activity in the Auslands-Organisation was in no
way connected with the Volksbund für das Deutschtum im
Ausland.’ ”—Signed—“Alfred Hess. Sworn to and subscribed
on 19 March 1946.”</p>
</div>
<p class="pindent">The witness Alfred Hess was then cross-examined in connection
with his interrogation. I assume that the Prosecution want to
submit this cross-examination themselves to the Tribunal. But if
this cross-examination and the questions belonging to it have not
yet been translated, it might perhaps be practicable if it were done
directly, in this connection.</p>
<p class="pindent">MR. THOMAS J. DODD (Executive Trial Counsel for the United
States): If it please the Tribunal, we have received the cross-interrogatories
but I suggest respectfully that, rather than take the time
to read them, we offer them and if the Court will permit us, have
them translated into the four languages. It will take another 10 minutes
or so to read them and we are not interested in doing it unless
the Tribunal feels that we should.</p>
<p class="pindent">THE PRESIDENT: Yes, certainly, Mr. Dodd.</p>
<p class="pindent">DR. SEIDL: Mr. President and Gentlemen, I do not know whether
the affidavit of Ambassador Gaus submitted by me yesterday has
been translated and whether the Tribunal has received these translations
already. Yesterday at midday I gave six copies to the
information office and have heard nothing further since.</p>
<p class="pindent">THE PRESIDENT: Can the Prosecution inform the Tribunal
what the position is?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, the Prosecution has
not had a copy of this affidavit yet so we do not know what is in it.
We suggest that perhaps Dr. Seidl could postpone the reading of
that until we have had a chance to consider it.
<span id="Page_79" title="79"></span></p>
<p class="pindent">THE PRESIDENT: Yes, I am afraid that must be postponed.</p>
<p class="pindent">DR. SEIDL: Yes. Now I turn to Volume 3 of the document book.</p>
<p class="pindent">If it please the Tribunal, this volume of the document book contains,
in substance, statements and quotations taken from books and
speeches of foreign statesmen, diplomats, and political economists,
regarding the history and origin of the Versailles Treaty, the contents
of the Versailles Treaty, the territorial changes made by this
treaty, such as the question of the Polish Corridor, and above all the
disastrous economic consequences which this treaty had for Germany
and also for the rest of the world.</p>
<p class="pindent">THE PRESIDENT: Yes, Sir David?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, I have read the documents
in this book and I should like just to say one or two words
about them.</p>
<p class="pindent">They are opinions expressed by a great variety of gentlemen,
including politicians, economists, and journalists. They are opinions
that are expressed polemically and some of them journalistically,
and with most of them one is familiar and knew them when they
were expressed 15 to 25 years ago.</p>
<p class="pindent">Now, while I submit, as I have submitted to the Tribunal, that
the whole subject is too remote, I have a suggestion which I hope
the Tribunal will consider reasonable, that the Prosecution should,
as I suggested yesterday, let this book go in at the moment <span class="it1">de bene
esse</span> and that when Dr. Seidl comes to making his final speech he
can adopt the arguments that are put forward by the various gentlemen
whom he quotes, if he thinks they are right. He can use the
points as illustrations, always provided the thesis that he is developing
is one which the Tribunal thinks relevant to the issues before
it. That will preserve for Dr. Seidl the advantage of the right to use
these documents subject, as I say, to the relevancy of the issues, but
I suggest that it would be quite wrong to read them as evidence at
the moment. They are merely polemical and journalistic opinions
and directed to an issue which the Prosecution has submitted, and
I do submit, is too remote.</p>
<p class="pindent">However, I am most anxious that Dr. Seidl should have every
advantage for his final speech. Therefore, I suggest it would be convenient
if they were put in without being read at the moment and
were left subject to the limitation of relevancy, which can be considered
when all the evidence is before the Tribunal, for him to
make use of in his final speech.</p>
<p class="pindent">DR. SEIDL: Mr. President, may I shortly...</p>
<p class="pindent">THE PRESIDENT: Just one moment, Dr. Seidl. We will hear you
in a moment—perhaps it would be better to hear what you have to
<span id="Page_80" title="80"></span>
say now. Do you think the suggestion made by Sir David Maxwell-Fyfe
would be one which would be acceptable to you?</p>
<p class="pindent">DR. SEIDL: Mr. President, at first glance the suggestion of Sir
David Maxwell-Fyfe seems to be very reasonable. But I believe I
must say that if the matter is treated in that way great difficulties
will arise for the Defense. For example the arguments on relevancy,
which in their nature belong in the presentation of evidence and
must be heard there, will be postponed until the final speech of the
Defense. This would mean that the defense counsel in his final
speech would be interrupted again and again; that he would have
to argue for the relevancy of his quotations; that perhaps whole
parts of his speech would fall by the wayside in that manner; and
that in that way the danger would arise that the cohesion of the
speech will be broken completely.</p>
<p class="pindent">THE PRESIDENT: Yes, Sir David.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, that is a danger which
every advocate has to meet, that certain portions of his speech may
not be deemed relevant, but I thought that that might be a helpful
way out. But if it is not accepted, then the Prosecution must respectfully
but very strongly submit that the issues of the terms of the
Treaty of Versailles are not relevant to this Tribunal.</p>
<p class="pindent">I have already argued that and I do not want to develop it at
great length. I do want to make it clear that the questions which
are raised by the quotations here were, of course, the subject of
political controversy in practically every country in Europe, and
different opinions were expressed as to the rightness and the practicality
of the provisions, especially the economic provisions of the
Treaty of Versailles. I am not disputing that that is a matter of
controversy, but I am saying that it is not a controversy that should
come before this Tribunal. I myself have replied to practically all
the quotations from the English statesmen here as a politician over
the past years, and I am sure many people in this Court must have
taken one view or the other, but that is not a relevant issue to this
Tribunal, and, of course, especially is it wrong in my view to put
forward as evidential matter opinions expressed by one side in the
controversy. Every one of these speeches, as far as they were
English, was either preceded by matters to which it was a reply or
was followed by a reply, and I should think the same applies to
those of Senator Borah in the United States.</p>
<p class="pindent">These matters—this is my second point—are not really evidential,
and this is a point for argument; and it will have to be decided what
is a convenient time for the Tribunal to decide on whether this is a
relevant issue. But that was why I put forward this suggestion that
it was better to decide it when the whole of the true evidence of
<span id="Page_81" title="81"></span>
fact had been put before the Tribunal. But I do want, apart from
my suggestion, to make quite clear that as regards relevance, the
Prosecution unitedly submit that the rightness or practicality of the
provisions of the Treaty of Versailles is not a relevant matter. The
other argument—I want to distinguish between the two—the other
argument has been adumbrated by Dr. Stahmer as to the actual
terms of the preamble to the military clauses. That is quite a
different point which we can discuss when, as I understand, certain
propositions of law are to be put forward by one of the defense
counsel on behalf of the Defense. But, as I say, the rightness and
practicality of the Treaty and especially the economic clauses is a
subject of enormous controversy on which there are literally thousands
of different opinions from one shade to the other, and I submit
it is not an issue before this Court, and, secondly, I submit this is not
evidence. It is not evidential matter, even if it were an issue.</p>
<p class="pindent">DR. SEIDL: May I perhaps reply briefly?</p>
<p class="pindent">THE PRESIDENT: Then, Sir David, your proposition would be
that Dr. Seidl could not quote from any of these documents?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, certainly, yes, on my
premise that it is irrelevant matter, he could not.</p>
<p class="pindent">THE PRESIDENT: Yes. They are not admissible.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: They are not admissible.</p>
<p class="pindent">THE PRESIDENT: Yes.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My original suggestion was of
course, leaving over the discussion of whether they are admissible
until all the evidence had been filed, but if that is not accepted,
I submit bluntly if I may use the word with all respect—that they
are not admissible.</p>
<p class="pindent">THE PRESIDENT: Now, Dr. Seidl.</p>
<p class="pindent">DR. SEIDL: May I reply briefly, Mr. President?</p>
<p class="pindent">THE PRESIDENT: Yes, yes.</p>
<p class="pindent">DR. SEIDL: It would indicate a complete misinterpretation of my
intentions if one were to assume that by the submission of this document
book I wanted to show whether or not the Treaty of Versailles
is an expression of statesmanly wisdom. I am not concerned with
that here.</p>
<p class="pindent">With the submission of this document it is to be shown, or rather
there is to be brought under discussion:</p>
<p class="pindent">Firstly: Whether the opposite side at the conclusion of the Treaty,
in the preliminary negotiations—I call your attention to Wilson’s
Fourteen Points—was not guilty for its part, of violation of the
<span id="Page_82" title="82"></span>
general treaty obligations, whether a <span class="it1">culpa in contrahendo</span> is not to
be assumed here.</p>
<p class="pindent">Secondly: The presentation of the documents should show
whether the opposite side complied with the obligations arising from
the treaty, in order to establish—that is, to give the Tribunal the
opportunity of establishing—in this way the legal inferences which
Germany might draw from this.</p>
<p class="pindent">Thirdly: The Treaty of Versailles and its violation by the defendants
forms the nucleus of Count One of the Indictment, namely, the
Conspiracy charged by the Prosecution. The Prosecution, in replying
to a question of the Tribunal as to when the conspiracy may be said
to have started, has said that the date might be set as far back
as 1921.</p>
<p class="pindent">Fourthly: The Prosecution has extensive...</p>
<p class="pindent">THE PRESIDENT: I have not the least idea what you meant by
the last point. I do not understand what you said in the last point
in the least.</p>
<p class="pindent">DR. SEIDL: I wanted to say that for the beginning of the Conspiracy
alleged by the Prosecution, the Treaty of Versailles played a
decisive part, and that there is at least some causal nexus between
the origin of this treaty and the alleged Conspiracy. Before there
can be talk of illegality and of guilt, the facts have to be established
which were causative for the Conspiracy charged by the Prosecution.</p>
<p class="pindent">Fourthly: The Prosecution has submitted extensive evidence on
the development of the NSDAP. Numerous document books were
submitted to the Court to show the growth in membership, to
demonstrate the increase in the Reichstag mandates. Now, if this
evidence was relevant, it is my assertion that also the circumstances
and the facts that first enabled this rise of the Party at all must be
relevant, if only from the viewpoint of causal nexus.</p>
<p class="pindent">THE PRESIDENT: Is it your contention that the opinion of a
journalist after the Treaty of Versailles was made, stating that, in
his opinion, the Treaty of Versailles was unjust to Germany, would
be admissible either for the interpretation of the Treaty or for any
other purpose with which this Tribunal is concerned?</p>
<p class="pindent">DR. SEIDL: Mr. President, I admit that of course the isolated
opinion of a foreign journalist has not in itself to be a relevant
document. But I do maintain that the opinion of Secretary of State
Lansing on the coming about of the Treaty of Versailles and his
connection with the history of this treaty must be of some evidential
relevance. What weight attaches to his opinion is a question which
cannot yet be established at this point. This question can be decided
by the Tribunal only when the complete evidence has been submitted.
I maintain further that the opinion of the Chairman of the
<span id="Page_83" title="83"></span>
Committee of Foreign Affairs of the Senate of the United States on
the Treaty of Versailles, about its formulation, about its effects
within the Conspiracy alleged by the Prosecution which purportedly
is said to be directed chiefly against the Treaty of Versailles can
<span class="it1">prima facie</span> have value as evidence. The same applies to most of the
other statements quoted in this document book. I would like to call
attention to Gustav Cassel, to John Maynard Keynes, the official
financial advisor of the British Government, and to a number of
others.</p>
<p class="pindent">THE PRESIDENT: It is your contention that because of the provisions
of the Versailles Treaty or because of an infraction of those
provisions by the signatory powers, Germany was justified in making
an aggressive war?</p>
<p class="pindent">DR. SEIDL: I cannot answer that now definitely, so long as I
have not heard the evidence of the other defendants. I do assert,
however, that by violation of the Treaty of Versailles by the opposite
side, under certain circumstances Germany or the defendants could
infer the right to rearm, and that is an infraction of the Treaty of
Versailles with which the defendants are charged. As far as the right
to an aggressive war is concerned, I should not like to make any
positive statements at least until such time as the Tribunal has taken
official notice of the affidavit of Ambassador Gaus.</p>
<p class="pindent">THE PRESIDENT: One more question I should like to ask you:
Are you saying that the Fourteen Points which were laid down by
President Wilson are admissible evidence to construe the written
document of the Versailles Treaty?</p>
<p class="pindent">DR. SEIDL: I do not say that the Fourteen Points of Wilson,
<span class="it1">per se</span>, are admissible evidence. I do assert, on the other hand, that
the connection between these Fourteen Points of Wilson and the
Treaty of Versailles, and the contradiction resulting therefrom are of
causal significance for the Conspiracy alleged by the Prosecution.</p>
<p class="pindent">THE PRESIDENT: Then you are really saying that the Versailles
Treaty, insofar as it departed from the Fourteen Points, was an
unjust treaty?</p>
<p class="pindent">DR. SEIDL: Mr. President, whether the treaty was just or not is
a point which I do not wish to prove with this document at all.
Whether the treaty was unjust or not is in my opinion a fact which
perhaps is beyond the scope of these proceedings. I do assert,
however, that the treaty, at least in many of its terms, did not bring
that which the victorious states themselves expected of it.</p>
<p class="pindent">THE PRESIDENT: Do you wish to add anything more, Dr. Seidl?</p>
<p class="pindent">DR. SEIDL: Not at this point.</p>
<p class="pindent">DR. RUDOLF DIX (Counsel for Defendant Schacht): Since it is a
very fundamental question which has been raised now for discussion
<span id="Page_84" title="84"></span>
by Sir David, and since the Defense must always calculate on the
possibility that the Tribunal, even at this point, may make a decision
on the question of whether and how far such documentary material
as that discussed can be produced, I consider myself duty-bound to
add to the statements of my colleague, Dr. Seidl, with whom I
agree fully, just a few supplementary words. And I would like to
reply to the very precise question of Your Lordship which starts,
“Do you consider it relevant...?” I believe—and I will avoid any
repetition—that a very vital point as far as relevancy is concerned
has not been brought out yet, and that is the subjective aspect; that
is the relevancy of the investigation of evidence and of facts regarding
the subjective state of the individual defendant, that is, of the
facts as seen from within.</p>
<p class="pindent">If, for example, one of the defendants committed an act which
was, considered purely objectively, a breach of the Treaty of Versailles,
then, as far as criminal law is concerned and looking at it
from the subjective view, it is of great significance whether in the
opinion of reasonable, just, and educated men of all nations, he acted
with an attitude and with a viewpoint which was not merely his
special viewpoint, but that of the most serious men of the various
nations and also of those nations which fought against Germany in
the years 1914-18. In order not to be too abstract, I should like to
cite a concrete example:</p>
<p class="pindent">A defendant holds the opinion that he is entitled to rearmament—not
to aggressive war; I will not touch this question. He considers
rearmament justified, either because the treaty has not been kept
by the other side or because owing to <span class="it1">expressis verbis</span>, or to some
action, it is to be considered obsolete. In my opinion it is of decisive
relevancy whether this defendant with this point of view, which
explains his action, is alone in all the world, or whether the opinion
which guides his action is held by men who are to be taken seriously,
and who belonged to other nations, even to those who in the years
1914-18 stood on the other side and were his enemies.</p>
<p class="pindent">Rearmament according to the Prosecution, as I understand, is
not a crime, as such, but is merely used by the Prosecution as a
charge for the proving of the crime of having carried on an aggressive
war. If, now, a defendant can prove that he acted from clean
and decent views, views which, as stated, were held by such men of
other nations as I have described, and acted conscientiously and with
a clear conscience both as regards international law and international
morals and also as regards the needs of his country, then
this material, which contains opinions, literary statements, speeches,
that coincide with the views of the defendant in question, is not only
of relevant, but of entirely decisive significance. This viewpoint
I ask the Tribunal to bear in mind, if it desires to decide now the
<span id="Page_85" title="85"></span>
question of principle which Sir David has just now raised for debate,
and which he had to raise, as I fully recognize. Moreover I am also
now in the agreeable position of being able to agree with Sir David
in the practical handling of this matter. I too—and I am speaking
now for myself only—would prefer to have the decision on this
question postponed until the time suggested by Sir David. As far as
I am concerned I will accept the disadvantages, which Dr. Seidl is
right in seeing, because an advantage will result if the Tribunal
decides this question at that time, since it will then have a much
larger view on all questions and shades which are important for the
decision. And at this point I am not at all in a position to speak comprehensively
about them, for I do not want to make any summarizing
speech, but just to treat one aspect of this question of evidence.</p>
<p class="pindent">DR. MARTIN HORN (Counsel for Defendant Von Ribbentrop):
I should like to add a few remarks to those made by my colleague
Dr. Dix. I request the Tribunal...</p>
<p class="pindent">THE PRESIDENT: The Tribunal would like to know how many
of the Defense Counsel think that they are entitled to address them.
If Dr. Horn wishes to add a short argument, the Tribunal are prepared
to hear it, but they are not prepared to hear all the defendants’
counsel upon points such as this, at this stage, and if any of the
other defendants’ counsel desires to address them, they will decide
now whether they will hear any more or not.</p>
<p class="pindent">It is understood, then, that Dr. Horn alone will address a short
argument to the Tribunal. If it is not, then the Tribunal will decide
whether they will hear any more argument upon the subject.</p>
<p class="pindent">DR. HORN: I cannot encroach on the rights of my colleagues in
this question, naturally, Mr. President. I should like personally to
make only a very brief statement on the legal points.</p>
<p class="pindent">THE PRESIDENT: Well, you must consult your colleagues then.</p>
<p class="pindent">DR. HORN: If you wish a decision on this question now, Mr.
President, I must ask my colleagues beforehand, of course.</p>
<p class="pindent">THE PRESIDENT: Certainly.</p>
<p class="pindent">[<span class="it1">There was a pause in the proceedings while the Defense conferred.</span>]</p>
<p class="pindent">DR. HORN: May I make first a preliminary remark, Mr. President,
to what has just been said to me by my colleagues. Firstly, this
decision has for the Counsel for the organizations a very particular
interest.</p>
<p class="pindent">For myself personally I would like to make the following
remarks: The Prosecution...</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, I asked you to consult the other
defendants’ counsel and ascertain whether they were willing that
<span id="Page_86" title="86"></span>
you should be heard, and you alone. That is the only terms upon
which I am prepared to hear you.</p>
<p class="pindent">[<span class="it1">There was a pause in the proceedings while the Defense conferred.</span>]</p>
<p class="pindent">DR. HORN: Yes, Mr. President, my colleagues are agreed that I
shall make the last statements on this point.</p>
<p class="pindent">THE PRESIDENT: One moment—very well. Go on.</p>
<p class="pindent">DR. HORN: There is no doubt that the Prosecution, as far as vital
questions are concerned, base their case on infractions of the Versailles
Treaty. To these treaty infractions, it is absolutely necessary,
in my opinion, to submit the facts which allow the legality of this
treaty to be judged. There is no doubt that this treaty was signed
under duress. It is recognized in international law that such treaties
from the legal point of view have grave deficiencies and are
infamous. In my opinion we must be allowed to submit the facts
that serve to show the soundness of this assertion and legal viewpoint.
A further question—and if I have understood correctly, this
is Sir David’s point—is that of the polemic analysis of the legal,
political, and economic consequences of this treaty.</p>
<p class="pindent">I do not wish to make any further statements on this point, but
I would like to ask that my first request be granted, that the legal
documentary facts be allowed which would permit a judgment on
the legal value of the Versailles Treaty.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: May it please the Tribunal, if
I might deal first with the argument which Dr. Dix has put forward.
As I understood his first main proposition, it was this: That if a
defendant has committed an act which is an infraction of the treaty
and can show that in the opinion of reasonable and just and educated
men in the states who were the other parties to the treaty, the treaty
was so bad that an infraction was justifiable, that is a permissible
argument.</p>
<p class="pindent">I submit that it is, with great respect to Dr. Dix, an unsound
argument and baseless, from any principle either of law or of
materiality. Once it is admitted that there is a treaty and that an
infraction is made, and it follows from the example that Dr. Dix was
dealing with that, these are the conceded facts. It is no answer to
say that a number of admirable people in the countries which were
parties to the treaty believed that its terms were wrong. The treaty
is there and the person who knowingly makes an infraction is
breaking the treaty, however strong is his support.</p>
<p class="pindent">In his second point Dr. Dix moved to quite different grounds. He
said that this evidence might be relevant in the special reference to
the question of rearmament because it might show that the treaty
was considered obsolete. Now, it is a rare but nonetheless existing
doctrine of international law that treaties, usually minor treaties,
<span id="Page_87" title="87"></span>
can be abrogated by the conduct of the contracting parties. I would
not contest that you cannot get examples of that, although they are
very rare and generally deal with minor matters. But this evidence
which is before the Tribunal at the moment is not directed to
that point at all. This is, in the main, contemporary polemic evidence
saying that certain aspects of the treaty were bad, either as regards
political standards or economic standards. That is a totally different
argument from the one which Dr. Dix admirably adumbrated—which
is one which if it came up would have to be faced—that a
treaty has become obsolete or that the breaches have been condoned
and that, therefore, the terms have really ceased to exist.</p>
<p class="pindent">My answer to that is that this evidence is not directed to that
point at all.</p>
<p class="pindent">Now, if Dr. Dix will forgive me, and I am sure the fault was
mine, I did not quite appreciate what he termed his subjective argument.
But insofar as I did appreciate it, there seems to be a very
good answer: that if he seeks to suggest that a defendant’s guilt may
be less because he, that defendant, believed that the treaty was bad,
that is essentially a matter which can be judged by the Tribunal
who will hear that defendant and appreciate and evaluate his point
of view. It really does not help in deciding whether the Defendant
Hess acted because he thought that the Treaty of Versailles was a
bad treaty, to know what the editor of the <span class="it1">Observer</span>, which is a
Sunday paper in England, expressed as his views some twenty years
ago, or the <span class="it1">Manchester Guardian</span> or indeed, with all respect to them,
what distinguished statesmen have said in writing their reminiscences
years after a matter occurred. The subjective point is—this
is my submission—an important point in deciding on evidence. The
subjective point can be answered by the defendant himself, and the
view of the defendant which the Tribunal will receive.</p>
<p class="pindent">Now, Dr. Horn has opened up a much wider question, and one
which I submit is entirely irrelevant and beyond the scope of these
proceedings.</p>
<p class="pindent">He wishes the Tribunal to try whether the Treaty of Versailles
was signed under duress. Well, that, of course, would involve the
whole consideration of the Government of the German Republic, the
position of the plenipotentiaries, and the legal position of the persons
who negotiated the treaty.</p>
<p class="pindent">The answer to that is that this Tribunal is concerned with certain
quite clearly stated offenses, fully particularized, which occurred
at the time that is stated in the Indictment; and all the evidence
that is given as to the actions of the pre-Nazi German Government,
and indeed of the Nazi Government, shows that for years Versailles
was accepted as the legal and actual basis on which they must work,
and various different methods were adopted in order to try to secure
<span id="Page_88" title="88"></span>
changes of the treaty, and I need not go into, with the Tribunal, the
whole frame work of the Locarno Treaties, recognizing Versailles,
which were signed in 1925, and which were treated as existing and
in operation by the Nazi Government itself.</p>
<p class="pindent">With that, these actual facts, it would, in my submission, be
completely remote, irrelevant, and contrary to the terms of the
Charter, for this Tribunal to go into an inquiry as to whether the
Treaty of Versailles was signed under duress.</p>
<p class="pindent">As I gathered, Dr. Horn was not so much interested in the economic
clauses and their rightness or wrongness; but I should respectfully
remind the Tribunal that that is a matter which is before them
at the moment—that here we have, as I have pointed out before—and
I do not want to repeat myself—a number of opinions expressed
by people of varying eminence and with varying degrees of
responsibility at the time that they expressed them. And while
strongly maintaining the position which I have endeavored to express
with regard to the treaty, I do equally impress my second point:
That to accept as matters of evidence statements which in the main
are made from a polemical standpoint, either in answer to an attack
or in an attack with background of the politics of the state in which
they were made, is simply a misuse of the term “evidence”. That
is not evidence of any kind, and I equally—not equally because the
first point is one of primary importance, which I respectfully urge
to the Tribunal—but I also suggest that to tender in evidence
matters of that kind is a misuse of the term “evidence,” that they
are matters of argument which an advocate may adopt if the argument
is a relevant one, but they should not be received in evidence
by the Tribunal for that reason.</p>
<p class="pindent">THE TRIBUNAL (Mr. Francis Biddle, Member for the United
States): Sir David, is there anything in the Versailles Treaty that
either calls for disarmament by the signatories other than Germany
or which looks to such disarmament; and, if there is, could you give
us the reference to it?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: Yes, it is the preamble to the
Military Clauses. That is the point which is usually relied on. It is
about four lines at the beginning of the Military Clauses, and, in
quite general terms, it looks to a general disarmament after Germany
has disarmed. Of course, the position was that—I think I have got
the dates right—disarmament was accepted. Whether, in view of
the evidence in this case, it should have been accepted does not
matter; it was accepted in 1927. After that, you may remember,
there were a number of disarmament conferences which examined
that question, and eventually in 1933 Germany left the then existing
disarmament conference.
<span id="Page_89" title="89"></span></p>
<p class="pindent">Now, I am trying to be entirely objective. I do not want to put
the Prosecution view or the Defense view, but that is the position.</p>
<p class="pindent">THE TRIBUNAL (Mr. Biddle): I am not quite clear. When you
say “accepted,” you mean that the extent of the disarmament called
for had been accepted by Germany?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: Yes, the other way around: that
Germany’s response to the demand of Versailles was accepted by
the Allies in 1927, and the Disarmament Commission which had been
in Germany then left Germany under, I think, a French General
Denoue.</p>
<p class="pindent">THE TRIBUNAL (Mr. Biddle): Then, what I understand you to
argue is that nothing contained in this folder has anything to do
with that possible issue.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: No, no.</p>
<p class="pindent">THE TRIBUNAL (Mr. Biddle): That is the point.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: It is not on that issue. I mean
we will deal with that issue when we come to it. I rather thought
from some words that Dr. Stahmer dropped that that would be one
of the points which we should meet in the general argument on law
which will be presented, which the Defense Counsel...</p>
<p class="pindent">DR. SEIDL: I believe that Sir David is under a slight misconception.
In Book 3 of the document book for the Defendant Hess there
are also a number of citations of foreign statesmen that refer to this
military clause in the Versailles Treaty and in which it is stated that
Germany fulfilled her obligations in the Versailles Treaty, but that
the reciprocal obligations in it for the opposite side were not fulfilled.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: Well, I am sorry. I did not
remember any. I have read it through, and there may be some
collateral matters dealing with that, but—and I do not think that
I am doing Dr. Seidl’s great industry in collecting these matters an
injustice in saying that if they do exist they are collateral and the
main point of this is an attack on the political and economic clauses
of the treaty. I hope that I have done him justice. I certainly intended
to do so. That is the impression made on me.</p>
<p class="pindent">THE PRESIDENT: The Tribunal will adjourn.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00009">[<span class="it1">The Tribunal recessed until 1400 hours.</span>]</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?398639ae